import store from '@/store/index';

export default [
  {
    path: '/',
    name: 'home',
    beforeEnter: (to, from, next) => {
      const isEditor = store.getters['user/isEditor'];
      const isClient = store.getters['user/isClient'];
      const isAgency = store.getters['user/isAgency'];

      // Editor goes to orders
      if (isEditor) {
        next({
          name: 'orders'
        });
        return;
      }

      // Non-agency clients go directly to gallery, but only if they're not coming from gallery
      // to avoid redirect loops
      if (isClient && !isAgency && from.name !== 'gallery') {
        next({
          name: 'gallery'
        });
        return;
      }

      // Everyone else (admins, agency clients, photographers) goes to the normal home page
      // Non-agency clients coming from gallery are also allowed to proceed
      next();
    },
    component: () => import(/* webpackChunkName: "home" */ '@views/HomePage.vue')
  },
  {
    path: '/orders',
    name: 'orders',
    query: { view: 'list' || 'grid' },
    beforeEnter: (to, from, next) => {
      const hasShoot = store.getters['user/hasShoot'];
      const isClient = store.getters['user/isClient'];

      // If client doesn't have shoots, redirect to gallery, but avoid redirect loops
      if (isClient && !hasShoot && from.name !== 'gallery') {
        next({
          name: 'gallery'
        });
        return;
      }

      // Allow access for clients with shoots, non-clients, or if coming from gallery
      next();
    },
    component: () => import(/* webpackChunkName: "home" */ '@views/Orders.vue')
  }
];
